import React, { useEffect, useState } from 'react';
import { Container, Table, Row, Col } from 'react-bootstrap';
import classes from './style.module.css'
import League from './League'
import { connect } from "react-redux"
import { GREYHOUND_TABLE_COLUMNS_STATIC, GREYHOUND_TABLE_ALL_STATIC } from '../../constants/Constants'
import { SET_SOCCER_LEAGUES_STATE, SET_SELECTION_STATE } from "../../redux/actions"
import sortIconImage from "../../assets/images/sort_both.png"
import { getRaceSummary, getAllRaceDetails, getRaceDetails } from '../../service/backend-api-service';
import Spinner from "../UI/Spinner"
import { Button, ButtonGroup } from 'react-bootstrap'
import "react-sliding-pane/dist/react-sliding-pane.css"
import RaceSlidingPane from "../RaceSlidingPane"
import VolumeMatched from './League/VolumeMatched';

const LeagueTable = (props) => {
    const [sortOrder, setSortOrder] = useState(true) // true - ascending and false - descending
    const [sortColumn, setSortColumn] = useState(null)
    const [loadingState, setLoadingState] = useState(1)
    const [race, setRace] = useState({})
    const [raceType, setRaceType] = useState(null)
    const [raceSummary, setRaceSummary] = useState(null)

    const staticColumns = []
    for (let value in GREYHOUND_TABLE_COLUMNS_STATIC) staticColumns.push(GREYHOUND_TABLE_COLUMNS_STATIC[value])

    const staticColumnsAll = []
    for (let value in GREYHOUND_TABLE_ALL_STATIC) staticColumnsAll.push(GREYHOUND_TABLE_ALL_STATIC[value])

    const finalColumns = raceType === 'ALL' ? [...staticColumnsAll] : [...staticColumns];



    const sortIconClickedHandler = columnId => {
        setSortColumn(columnId)
        if (sortColumn === columnId) setSortOrder(!sortOrder)
    }

    const tableHeaders = finalColumns.map(column => {
        let sortIcon = null
        const description = column.description
        if (!(column.id == GREYHOUND_TABLE_COLUMNS_STATIC.ROW_NUM.id ||
            column.id == GREYHOUND_TABLE_COLUMNS_STATIC.ODD_DETAILS.id ||
            column.id == GREYHOUND_TABLE_COLUMNS_STATIC.WIN_DETAILS.id))
            sortIcon = <img src={sortIconImage} alt="Sort" onClick={() => sortIconClickedHandler(column.id)} />
        if (column.id === GREYHOUND_TABLE_COLUMNS_STATIC.ODD_DETAILS.id) {
            return (
                <th key={column.id}><ButtonGroup size="sm">
                    <Button style={{ fontSize:"10px", padding:"3px", backgroundColor: "#74BBEF" }} variant="outline-dark"><b>Bk</b></Button>
                    <Button style={{ fontSize:"10px", padding:"3px", backgroundColor: "#F8AAB8" }} variant="outline-dark"><b>Ly</b></Button>
                </ButtonGroup>
                </th>
            );
        } else {
            return (
                <th key={column.id}>{description}</th>
            );
        }
    })

    useEffect(() => {
        const fetchData = async () => {
            if (race && race != 'undefined') {
                setLoadingState(0)
                let apiData = race.type === 'ALL' ? await getAllRaceDetails(race.date) : await getRaceDetails(race)
                let raceSummary = race.type === 'ALL' ? null : await getRaceSummary(race)
                setRaceSummary(raceSummary);
                props.setSoccerLeaguesState(apiData)
                if (apiData) {
                    setLoadingState(2)
                } else {
                    setLoadingState(1)
                }
            }
        }
        setRaceType(race.type)
        fetchData();

    }, [race])


    useEffect(() => {
        setRace({});
        setLoadingState(1)
        props.setSoccerLeaguesState(null)
    }, [props.selectionState])

    let itemList

    if (race.type === 'ALL') {
        itemList = props.soccerLeaguesState ?
            props.soccerLeaguesState.map((item, index) => {
                return <League key={item.runner + index} date={item.raceDay}
                    finalColumns={finalColumns} type="ALL" item={item} index={index} />
            }) : null
    } else {
        itemList = props.soccerLeaguesState ?
            props.soccerLeaguesState.map((item, index) => {
                return <League key={item.runner + index} date={race.raceDay}
                    finalColumns={finalColumns} item={item} index={index} />
            }) : null;
    }

    const volumeMatched = (race.type != 'ALL' && props.soccerLeaguesState && props.soccerLeaguesState.length > 0 &&
        props.soccerLeaguesState[0].bfMarketId) ?
        <VolumeMatched marketId={props.soccerLeaguesState[0].bfMarketId} /> : null

    const header = raceSummary ?
        <>
            <font style={{ fontSize: "1.4em" }}>
                    {raceSummary.title[0]} {raceSummary.title[2]} {raceSummary.title[3]}
                    {' '}{' '}{' '} 
                    {volumeMatched}
            </font>
            <div style={{ display: "none" }} id="fileName">
                {raceSummary.trackName}_{raceSummary.time}
            </div>       
         </>
        : null;

    const footer = raceSummary ?
        <>
            <font style={{ fontSize: "1.0em" }}>
            <b>{raceSummary.verdictText ?  'Analyst Verdict:' :""}</b>
            {raceSummary.verdictText ?  raceSummary.verdictText : ""} <br></br>
            <b>{raceSummary.verdictForecastText ?  'Betting Forecast:' :""}</b>
            
            {raceSummary.verdictForecastText ? raceSummary.verdictForecastText.substring(16) : ""} <br></br>
            
            <b>{raceSummary.smartStat ?  'Smart Stats:' :""}</b>
            
            {raceSummary.smartStat ? Object.entries(raceSummary.smartStat)
                .map((key, value) => key)
                .join(" ")
                :""
                }
            
            </font>
               
         </>
        : null;    

    let contentBody = null

    if (loadingState === 0) {
        contentBody = <Spinner />
    } else if (loadingState === 1) {
        contentBody = <div style={{ textAlign: "center" }}>Please select race</div>
    } else {
        contentBody =
            <>
                <b>{header} </b>
                <Table className="LeagueTable" style={{ fontSize:"10px"}} id="runnerDetails" triped bordered hover size="sm">
                    <thead>
                        <tr>
                            {tableHeaders}
                        </tr>
                    </thead>
                    <tbody>
                        {itemList}
                    </tbody>
                </Table>
                {footer}
            </>
    }


    return (
        <Container fluid className={classes.LeagueTable}>
            <Row>
                <Col sm={2} style={{ height: "546px", overflowY: "scroll", backgroundColor: "#6c757d" }}>
                    <RaceSlidingPane selectionDate={props.selectionState.selectionDate} raceSelectHandler={setRace} />
                </Col>
                <Col style={{ overflow: "scroll", paddingLeft:"1px" }} > {contentBody}</Col>
            </Row>
        </Container>
    )
}


const mapStateToProps = state => {
    return {
        soccerLeaguesState: state.soccerLeaguesState,
        selectionState: state.selectionState
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSoccerLeaguesState: payload =>
            dispatch({ type: SET_SOCCER_LEAGUES_STATE, payload: payload }),
        setSelectionState: payload =>
            dispatch({ type: SET_SELECTION_STATE, payload: payload })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeagueTable);